
/**
 * @overview 推荐编辑
 * @author jzhu
 * @date 2020-9-24
 */

import React from 'react'
import moment from 'moment'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, WizAvatarUpload, modelUtils } = framework_tool
let { WizCard, WizForm, WizSpin, WizRow, WizCol, WizButton, Wizmessage, WizTooltip, WizIcon } = component_tool
let { Session } = utils_tool
import { WizAuthority, WizTableForm } from '../../../common'

const getParamRecord = (history) => {
    let record = null
    if (history.location && history.location.pathname === '/featured/management/featuredUpd') {
        if (history.location.record) {
            record = history.location.record
            Session.set('featuredUpd', record)
        } else {
            record = Session.get('featuredUpd') || {}
        }
    }
    return record
}

const validator = (rule, value, callback) => {
    if (value) {
        if (value.orgIds && value.orgIds.length) {
            callback()
            return
        }
        if (value.positionIds && value.positionIds.length) {
            callback()
            return
        }
        if (value.positionCategoryIds && value.positionCategoryIds.length) {
            callback()
            return
        }
        if (value.personIds && value.personIds.length) {
            callback()
            return
        }
    }
    callback('请选择推荐范围')
}

const platforms = {
    'PC': 0,
    'APP': 1,
}

const positions = {
    '首页轮播': 0,
    '广告位': 1,
    '路径推荐位': 2,
    '任务推荐位': 3
}

const correspondence = {
    'PC': ['首页轮播', '广告位', '路径推荐位', '任务推荐位'],
    'APP': ['首页轮播', '', '路径推荐位', '任务推荐位'],
}

class FeaturedDetail extends WizContainer {

    componentName = 'FeaturedDetail'

    constructor(props) {
        super(props)
        let { history } = props
        let record = getParamRecord(history)
        let entityType
        let entityName
        let selectedPlatforms = []
        let optionalPosition = []
        let selectedPosition = []
        if (record && record.id) {
            entityType = record.entityType
            entityName = record.entityName
            selectedPlatforms = record.platforms
            selectedPosition = record.positions
            optionalPosition = this._optionalPosition(record.platforms)
        }
        this.state = {
            record,
            entityType,
            entityName,
            selectedPlatforms,
            optionalPosition,
            selectedPosition,
            linkContentDisible: true,
            featuredId: record?.id || ''
        }
    }

    /**
     * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
     * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
     */
    _componentDidRecover() {
        const { history } = this.props;
        let initialValue = {};
        if (history.location && history.location.pathname === '/featured/management/featuredUpd') {
            if (history.location.record) {
                initialValue = history.location.record;
                Session.set('featuredUpd', initialValue)
            } else {
                initialValue = Session.get('featuredUpd') || {};
            }
        }
        if (initialValue.id != this.state.record?.id) {
            // this.initialValue = initialValue
            this.setState({ record: initialValue, featuredId: initialValue.id })
        }
    }
    _optionalPosition = (value) => {
        let optionalPosition = []
        let platformObj = {}
        for (let [key, value] of Object.entries(platforms)) {
            platformObj[value] = key
        }
        value.map(code => {
            let platform = platformObj[code]
            let positionCodeArr = correspondence[platform].map(position => positions[position])
            return positionCodeArr
        }).forEach(arr => arr.forEach(item => !optionalPosition.includes(item) && optionalPosition.push(item)))
        return optionalPosition
    }

    _onSubmit = (values) => {
        let { id, startDate, endDate, carouselImg, busWxImg, advertisingImg, advertisingAppImg, pathImg, taskImg, ...rest } = values
        startDate = startDate.valueOf()
        endDate = endDate.valueOf()
        if (startDate > endDate) {
            wizNotice.error('生效时间不能大于失效时间')
            return
        }
        if (carouselImg && carouselImg.length) {
            carouselImg = carouselImg[0].fileId
        }
        if (busWxImg && busWxImg.length) {
            busWxImg = busWxImg[0].fileId
        }
        if (advertisingImg && advertisingImg.length) {
            advertisingImg = advertisingImg[0].fileId
        }
        if (advertisingAppImg && advertisingAppImg.length) {
            advertisingAppImg = advertisingAppImg[0].fileId
        }
        if (pathImg && pathImg.length) {
            pathImg = pathImg[0].fileId
        }
        if (taskImg && taskImg.length) {
            taskImg = taskImg[0].fileId
        }
        let apiParams = { id, startDate, endDate, carouselImg, busWxImg, advertisingImg, advertisingAppImg, pathImg, taskImg, entityName: this.state.entityName, ...rest }
        let action = id ? 'update' : 'create'
        this.doAction({
            path: 'featured/' + action,
            payload: {
                key: 'featured_save',
                apiParams
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('保存成功')
            this.jumpPage('replaceAndDelCrumb', '/featured/management')
        } else {
            wizNotice.error((nextProps.save && nextProps.save.msg) || '操作失败,请稍后尝试')
        }
        return true
    }

    /**
     * 重置
     */
    _onReset = () => {
        this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns col-item'>
                <WizCol span={24}>
                    <WizButton title='保存' icon='check' type='primary' htmlType='submit'>保存</WizButton>
                    <WizButton title='重置' icon='reload' onClick={e => this._onReset()}>重置</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    _render() {
        let { record } = this.state
        let title = record && record.id ? '编辑推荐' : '新增推荐'
        let formProps = {
            ref: 'form',
            key: this.state.featuredId || '',
            columns: this._columns(),
            record: record,
            onSubmit: this._onSubmit,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <WizCard>
                <WizSpin tip={'加载中'} spinning={this.props.featuredLoading}>
                    <WizForm className={'form-inline'} {...formProps} />
                </WizSpin>
            </WizCard>
        )
    }

    _entityTypeOnChange = (form, value) => {
        this._wizTableFormOnClear && this._wizTableFormOnClear()
        this.setState({ entityType: value, linkContentDisible: false })
    }

    _entityOnChange = (form, value, rows) => {
        let row = rows && rows.length && rows[0]
        let name = row ? row.name || row.title : undefined
        this.setState({ entityName: name })
    }

    _tableFormProps = () => {
        let { entityType } = this.state
        let config = { columns: [], tableApi: {} }
        let other = {
            onClearWiz: onClear => this._wizTableFormOnClear = onClear,
            selectType: 'radio'
        }
        switch (entityType) {
            case 0:
                config = WizTableForm.Config.program(this, { apiParams: { status: 1 } })
                break
            case 1:
                config = WizTableForm.Config.exam(this, { apiParams: { status: 1 } })
                break
            case 2:
                config = WizTableForm.Config.survey(this, { apiParams: { status: 1 } })
                break
            case 3:
                break
            case 15:
                config = WizTableForm.Config.apply(this, { apiParams: { status: 1 } })
                break
            case 20:
                config = WizTableForm.Config.content(this, { apiParams: { releaseState: 1, categoryIds: [constants.env.sys_content_category_gg_id] } })
                break;
            case 22:
                config = WizTableForm.Config.topic(this, { apiParams: { state: 1, nowDate: new Date().toDateString() } })
                break
            case 23:
                config = WizTableForm.Config.activity(this, { apiParams: { state: 1 } })
                break
            case 25:
                config = WizTableForm.Config.series(this, { apiParams: { state: 1 } })
                break;
            case 26:
                config = WizTableForm.Config.live(this, { apiParams: { stateList: [2, 3] } })
                break;
            case 12:
                config = WizTableForm.Config.path(this, { apiParams: { state: 2 } })
                break
            case 6:
                break
            case 59:
                config = WizTableForm.Config.practice(this, {apiParams: {status:1}})
                break    
            default:
                other.disabled = true
        }
        let tableFormProps = {
            ...config,
            ...other
        }
        return tableFormProps
    }

    /**
     * 发布平台变化时，计算可选推荐位并清除已选中的不可选推荐位
     * @param {*} form
     * @param {*} value
     */
    _platformsOnChange = (form, value) => {
        let optionalPosition = []
        let positionsValue = form.getFieldValue('positions')
        if (value && value.length) {
            optionalPosition = this._optionalPosition(value)
            positionsValue = positionsValue && positionsValue.length && positionsValue.filter(positionValue => optionalPosition.includes(positionValue))
        } else {
            positionsValue = []
        }
        form.setFieldsValue({ positions: positionsValue })
        this.setState({ selectedPlatforms: value, optionalPosition })
    }

    _positionsOnChange = (form, value) => {
        this.setState({ selectedPosition: value })
    }

    /**
     * 动态选项
     * @param {*} data
     * @param {*} flag
     */
    _dict = (data, flag) => {
        let { entityType } = this.state
        let taskTypeList = [0, 1, 26, 15, 45, 59]
        let dict = []
        for (let [key, value] of Object.entries(data)) {
            let item = { code: value, codeName: key }
            if (flag) {
                item.disabled = !this.state.optionalPosition.includes(value)
            }
            dict.push(item)
            if (flag && !taskTypeList.includes(entityType) && value === 3) {
                dict.splice(dict.indexOf(value), 1)
            }
        }
        return dict
    }

    /**
     * formItem配置
     */
    _columns = () => {
        let { record, selectedPlatforms, selectedPosition, entityType } = this.state;
        let taskTypeList = [0, 1, 26, 15, 45, 59]
        let platformDict = this._dict(platforms)
        let positionDict = this._dict(positions, true)
        let initRows = record && record.entityId ? [{ id: record.entityId, name: record.entityName, title: record.entityName }] : []
        let columns = [
            {
                name: 'id',
                formItem: {
                    type: 'hidden'
                }
            },
            {
                title: '关联类型',
                name: 'entityType',
                dataIndex: 'entityType',
                dict: [
                    { code: 0, codeName: '课程' },
                    { code: 1, codeName: '考试' },
                    { code: 2, codeName: '问卷' },
                    // { code: 3, codeName: '直播' },
                    { code: 15, codeName: '报名' },
                    { code: 20, codeName: '公告' },
                    // { code: 22, codeName: '话题' },
                    // { code: 23, codeName: '活动' },
                    { code: 25, codeName: '系列化课程' },
                    { code: 26, codeName: '直播' },
                    { code: 12, codeName: '培训路径' },
                    { code: 59, codeName: '练习' },
                    // { code: 37, codeName: '投票' }
                ],
                formItem: {
                    type: 'select',
                    onChange: this._entityTypeOnChange,
                    disabled: this.state.record && this.state.record.id ? true : false,
                    rules: [{ required: true, message: '请选择关联类型' }]
                }
            },
            {
                title: '关联内容',
                name: 'entityId',
                dataIndex: 'entityId',
                formItem: {
                    type: 'diy',
                    diy: WizTableForm,
                    ...this._tableFormProps(),
                    initRows,
                    onChange: this._entityOnChange,
                    disabled: this.state.record && this.state.record.id ? true : this.state.linkContentDisible,
                    rules: [{ required: true, message: '请选择关联内容' }]
                }
            },
            {
                title: '生效时间',
                name: 'startDate',
                dataIndex: 'startDate',
                formItem: {
                    type: 'datetime',
                    rules: [{ required: true, message: '请选择生效时间' }]
                }
            },
            {
                title: '失效时间',
                name: 'endDate',
                dataIndex: 'endDate',
                formItem: {
                    type: 'datetime',
                    rules: [{ required: true, message: '请选择失效时间' }]
                }
            },
            {
                title: '发布平台',
                name: 'platforms',
                dataIndex: 'platforms',
                dict: platformDict,
                formItem: {
                    type: 'checkbox',
                    onChange: this._platformsOnChange,
                    rules: [{ required: true, message: '请选择发布平台' }]
                }
            },
            {
                title: '推荐位',
                name: 'positions',
                dataIndex: 'positions',
                dict: positionDict,
                formItem: {
                    type: 'checkbox',
                    onChange: this._positionsOnChange,
                    rules: [{ required: true, message: '请选择推荐位' }]
                }
            },
            {
                title: <span>
                    PC、APP轮播图&nbsp;
                    <WizTooltip title="请上传大小不超过1MB,图片尺寸建议645*334">
                        <WizIcon type="question-circle-o" />
                    </WizTooltip>
                </span>,
                formItem: {
                    type: 'custom',
                    render: (record, form) => {
                        const { getFieldDecorator } = form
                        let initialValue = undefined
                        if (record && record.carouselImg) {
                            initialValue = [{ fileId: record.carouselImg }]
                        }
                        let formFieldOptions = { initialValue }
                        if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
                            && (selectedPlatforms.includes(platforms['PC']) || selectedPlatforms.includes(platforms['APP']))) {
                            formFieldOptions.rules = [{ required: true, message: '请选择上传PC、APP轮播图' }]
                        }
                        return (
                            <>
                                {
                                    getFieldDecorator('carouselImg', formFieldOptions)(
                                        <WizAvatarUpload
                                            key='icon'
                                            accept={'.jpg, .jpeg, .png'}
                                            listType={'picture-card'}
                                            aspectRatio={645 / 334}
                                            beforeUpload={(file) => {
                                                const isLt1M = file.size / 1024 / 1024 < 1
                                                if (!isLt1M) {
                                                    Wizmessage.error('PC、APP轮播图片不得超过1MB!')
                                                }
                                                return isLt1M
                                            }}
                                        />
                                    )
                                }
                            </>
                        )
                    }
                }
            },
            // {
            //   title: '企业微信轮播图',
            //   formItem: {
            //     type: 'custom',
            //     render: (record, form) => {
            //       const { getFieldDecorator } = form
            //       let initialValue = undefined
            //       if (record && record.busWxImg) {
            //         initialValue = [{ fileId: record.busWxImg }]
            //       }
            //       let formFieldOptions = { initialValue }
            //       if ((selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
            //         && selectedPlatforms.includes(platforms['凯迪拉克IQ']))
            //         || (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
            //         && selectedPlatforms.includes(platforms['雪佛兰企微']))
            //         || (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
            //         && selectedPlatforms.includes(platforms['别克企微']))
            //         || (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['首页轮播'])
            //         && selectedPlatforms.includes(platforms['凯迪拉克企微']))){
            //         formFieldOptions.rules = [{ required: true, message: '请选择上传企业微信轮播图' }]
            //       }
            //       return (
            //         <>
            //           {
            //             getFieldDecorator('busWxImg', formFieldOptions)(
            //               <WizAvatarUpload
            //                 key='icon'
            //                 accept={'.jpg, .jpeg, .png'}
            //                 listType={'picture-card'}
            //                 aspectRatio={500 / 560}
            //                 beforeUpload={(file) => {
            //                   const isLt1M = file.size / 1024 / 1024 < 1
            //                   if (!isLt1M) {
            //                     Wizmessage.error('企业微信轮播图片不得超过1MB!')
            //                   }
            //                   return isLt1M
            //                 }}
            //               />
            //             )
            //           }
            //         </>
            //       )
            //     }
            //   }
            // },
            {
                title: <span>
                    PC广告图&nbsp;
                    <WizTooltip title="请上传大小不超过1MB,图片尺寸建议1160*170">
                        <WizIcon type="question-circle-o" />
                    </WizTooltip>
                </span>,
                formItem: {
                    type: 'custom',
                    render: (record, form) => {
                        const { getFieldDecorator } = form
                        let initialValue = undefined
                        if (record && record.advertisingImg) {
                            initialValue = [{ fileId: record.advertisingImg }]
                        }
                        let formFieldOptions = { initialValue }
                        if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['广告位'])
                            && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['PC'])) {
                            formFieldOptions.rules = [{ required: true, message: '请选择上传PC广告图' }]
                        }
                        return (
                            <>
                                {
                                    getFieldDecorator('advertisingImg', formFieldOptions)(
                                        <WizAvatarUpload
                                            key='icon'
                                            accept={'.jpg, .jpeg, .png'}
                                            listType={'picture-card'}
                                            aspectRatio={1160 / 170}
                                            beforeUpload={(file) => {
                                                const isLt1M = file.size / 1024 / 1024 < 1
                                                if (!isLt1M) {
                                                    Wizmessage.error('广告图片不得超过1MB!')
                                                }
                                                return isLt1M
                                            }}
                                        />
                                    )
                                }
                            </>
                        )
                    }
                }
            },
            // {
            //     title: 'APP广告图',
            //     formItem: {
            //         type: 'custom',
            //         render: (record, form) => {
            //             const { getFieldDecorator } = form
            //             let initialValue = undefined
            //             if (record && record.advertisingAppImg) {
            //                 initialValue = [{ fileId: record.advertisingAppImg }]
            //             }
            //             let formFieldOptions = { initialValue }
            //             if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['广告位'])
            //                 && selectedPlatforms && selectedPlatforms.length && selectedPlatforms.includes(platforms['APP'])) {
            //                 formFieldOptions.rules = [{ required: true, message: '请选择上传APP广告图' }]
            //             }
            //             return (
            //                 <>
            //                     {
            //                         getFieldDecorator('advertisingAppImg', formFieldOptions)(
            //                             <WizAvatarUpload
            //                                 key='icon'
            //                                 accept={'.jpg, .jpeg, .png'}
            //                                 listType={'picture-card'}
            //                                 aspectRatio={464 / 136}
            //                                 beforeUpload={(file) => {
            //                                     const isLt1M = file.size / 1024 / 1024 < 1
            //                                     if (!isLt1M) {
            //                                         Wizmessage.error('广告图片不得超过1MB!')
            //                                     }
            //                                     return isLt1M
            //                                 }}
            //                             />
            //                         )
            //                     }
            //                 </>
            //             )
            //         }
            //     }
            // },
            {
                title: <span>
                    路径推荐图&nbsp;
                    <WizTooltip title="请上传大小不超过1MB,图片尺寸建议400*207">
                        <WizIcon type="question-circle-o" />
                    </WizTooltip>
                </span>,
                formItem: {
                    type: 'custom',
                    render: (record, form) => {
                        const { getFieldDecorator } = form
                        let initialValue = undefined
                        if (record && record.pathImg) {
                            initialValue = [{ fileId: record.pathImg }]
                        }
                        let formFieldOptions = { initialValue }
                        if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['路径推荐位'])) {
                            formFieldOptions.rules = [{ required: true, message: '请选择上传路径推荐图' }]
                        }
                        return (
                            <>
                                {
                                    getFieldDecorator('pathImg', formFieldOptions)(
                                        <WizAvatarUpload
                                            key='icon'
                                            accept={'.jpg, .jpeg, .png'}
                                            listType={'picture-card'}
                                            aspectRatio={400 / 207}
                                            beforeUpload={(file) => {
                                                const isLt1M = file.size / 1024 / 1024 < 1
                                                if (!isLt1M) {
                                                    Wizmessage.error('广告图片不得超过1MB!')
                                                }
                                                return isLt1M
                                            }}
                                        />
                                    )
                                }
                            </>
                        )
                    }
                }
            },


            taskTypeList.includes(entityType) ?
                {
                    title: <span>
                        任务推荐图&nbsp;
                        <WizTooltip title="请上传大小不超过1MB,图片尺寸建议400*207">
                            <WizIcon type="question-circle-o" />
                        </WizTooltip>
                    </span>,
                    formItem: {
                        type: 'custom',
                        render: (record, form) => {
                            const { getFieldDecorator } = form
                            let initialValue = undefined
                            if (record && record.taskImg) {
                                initialValue = [{ fileId: record.taskImg }]
                            }
                            let formFieldOptions = { initialValue }
                            if (selectedPosition && selectedPosition.length && selectedPosition.includes(positions['任务推荐位'])) {
                                formFieldOptions.rules = [{ required: true, message: '请选择上传任务推荐图' }]
                            }
                            return (
                                <>
                                    {
                                        getFieldDecorator('taskImg', formFieldOptions)(
                                            <WizAvatarUpload
                                                key='icon'
                                                accept={'.jpg, .jpeg, .png'}
                                                listType={'picture-card'}
                                                aspectRatio={400 / 207}
                                                beforeUpload={(file) => {
                                                    const isLt1M = file.size / 1024 / 1024 < 1
                                                    if (!isLt1M) {
                                                        Wizmessage.error('广告图片不得超过1MB!')
                                                    }
                                                    return isLt1M
                                                }}
                                            />
                                        )
                                    }
                                </>
                            )
                        }
                    }
                } : {},
            // {
            //     title: '推荐范围',
            //     name: 'authInfo',
            //     dataIndex: 'authInfo',
            //     formItem: {
            //         type: 'diy',
            //         diy: WizAuthority,
            //         rules: [{ required: true, validator }],
            //         showBlock: false,
            //         keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
            //     }
            // },
            {
                title: '推荐状态',
                name: 'state',
                dataIndex: 'state',
                dict: [
                    { code: 0, codeName: '草稿' },
                    { code: 1, codeName: '打开' },
                    { code: 2, codeName: '关闭' }
                ],
                formItem: {
                    type: 'radio',
                    initialValue: 0,
                    rules: [{ required: true, message: '请选择推荐状态' }]
                }
            }
        ]
        return columns
    }
}

const mapStateToProps = (state, ownProps) => {
    const { featured } = state
    const save = modelUtils.getModelEntity(featured, 'featured_save')
    const load = modelUtils.getLoadingState(state, 'featured')
    return {
        save,
        ...load
    }
}

export default connect(mapStateToProps)(FeaturedDetail)
